import { ContentTypes } from '../../constants'

const Types = {
    EDIT_CONTENT_FORM: 'EDIT_CONTENT_FORM',
    EDIT_CONTENT_FORM_VALUE: 'EDIT_CONTENT_FORM_VALUE',
    RESET_FORM: 'RESET_FORM',
    RESET_UPLOAD: 'RESET_UPLOAD',
}

const editForm = (contentType, form) => ({
    type: Types.EDIT_CONTENT_FORM,
    payload: form,
    meta: { contentType },
})

const editFormValue = (contentType, { name, value }) => ({
    type: Types.EDIT_CONTENT_FORM_VALUE,
    payload: { name, value },
    meta: { contentType },
})

const resetForm = (contentType) => ({
    type: Types.RESET_FORM,
    meta: { contentType },
})

/**
 * Reset upload form
 * @param {String} contentType resetUpload.types
 */
const resetUpload = (contentType) => {
    if (!Object.values(ContentTypes).includes(contentType)) {
        throw new Error('contentType value is not valid', contentType)
    }

    return {
        type: Types.RESET_UPLOAD,
        meta: { contentType },
    }
}

export { Types, editForm, editFormValue, resetForm, resetUpload }
